export interface ApiBaseSuccessProps<T> {
    data: T;
    status: number;
}

export default class ApiSuccess<T> {
    readonly status: number;

    readonly data: T;

    constructor(props: ApiBaseSuccessProps<T>) {
        this.data = props.data;
        this.status = props.status;
    }
}
